"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../index");

var _index2 = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _popup_styles = _interopRequireDefault(require("./popup_styles"));

var _popup_definition = _interopRequireDefault(require("./popup_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// utils
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : POPUP ~~~~~~~~~~ ========== */


var PopupMessage = (0, _reactJss.default)(_popup_styles.default)(function (props) {
  return _react.default.createElement(_index.SubPage, {
    name: "popupmessage type-".concat(props.type),
    klass: props.classes.popupmessage
  }, _react.default.createElement(_index.Copy, null, _react.default.createElement(_index.Title, null, !!props.title && _react.default.createElement("h5", null, props.title)), !!props.body && _react.default.createElement(_index.BodyCopy, null, props.body)), _react.default.createElement(_index.CTAs, null, !!props.buttonPrimary.text && _react.default.createElement(_index.Button, {
    name: (0, _index2.generateName)(props.buttonPrimary.text),
    variant: props.buttonPrimary.variant,
    type: 'action',
    disabled: props.buttonPrimary.disabled,
    action: !!props.buttonPrimary.action ? props.buttonPrimary.action : function () {
      return props.displayModal(false);
    },
    text: props.buttonPrimary.text,
    handleClick: props.buttonPrimary.handleClick,
    operation: props.buttonPrimary.operation,
    processing: props.buttonPrimary.processing
  }), !!props.buttonSecondary.text && _react.default.createElement(_index.Button, {
    name: (0, _index2.generateName)(props.buttonSecondary.text),
    variant: props.buttonSecondary.variant,
    type: 'action',
    disabled: props.buttonSecondary.disabled,
    action: !!props.buttonSecondary.action ? props.buttonSecondary.action : function () {
      return props.displayModal(false);
    },
    text: props.buttonSecondary.text,
    handleClick: props.buttonSecondary.handleClick,
    operation: props.buttonSecondary.operation,
    processing: props.buttonSecondary.processing
  })));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(PopupMessage, _popup_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = PopupMessage;
exports.default = _default;